<template>
    <div class="vue-template">
        <!-- Navigation -->
        <nav
            class="navbar bg-white fixed-top flex-row py-0"
            v-if="loginHeader && $route.name !== 'landing'"
        >
            <div class="container">
                <router-link class="navbar-brand" to="/"
                    ><img src="/img/eody-logo.png" width="170"
                /></router-link>
                <ul class="nav navbar-nav flex-row float-right">
                    <li class="nav-item">
                        <router-link v-if="!isLoggedIn" class="nav-link pr-3" to="/login"
                            >Login</router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link
                            v-if="!isLoggedIn"
                            class="btn btn-outline-primary"
                            to="/register"
                            >Register</router-link
                        >
                    </li>
                    <li class="nav-item">
                        <router-link v-if="isLoggedIn" class="nav-link pr-3" to="/my-account"
                            >Welcome, {{ firstName }} {{ lastName }}</router-link
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            href="javascript:void(0);"
                            v-if="isLoggedIn"
                            @click="logout"
                            class="nav-link pr-3"
                            >Logout</a
                        >
                    </li>
                </ul>
            </div>
        </nav>
        <!-- Main -->
        <div class="App">
            <div class="row">
                <div class="col-md-1" v-if="!loginHeader && !disableLeftPadding"></div>
                <div
                    :class="[
                        { 'col-md-11': !loginHeader && !disableLeftPadding },
                        { 'dashboard-header-padding': !loginHeader && !disableTopPadding },
                        { 'col-md-12': loginHeader || disableLeftPadding },
                    ]"
                >
                    <router-view
                        :key="$route.fullPath"
                        @login="login"
                        v-bind:isLoggedIn="isLoggedIn"
                        @logout="logout"
                        @hideHeader="hideHeader"
                        @hideFooter="hideFooter"
                    />
                </div>
            </div>
        </div>
        <!-- Footer -->
        <footer v-if="loginFooter">
            <div class="container">
                <!--<div class="footer-top">
                    <div class="row">
                        <div class="col-md-5">
                            <p class="footer-title">Our mission is to provide a free, world-class education to anyone, anywhere.</p>
                        </div>
                        <div class="col-md-7">
                            <div class="d-md-block d-none">
                                <div class="row">
                                    <div class="col-md-4">
                                        <a href="#" class="footer-link">About</a>
                                        <a href="#" class="footer-link">News</a>
                                        <a href="#" class="footer-link">Impact</a>
                                        <a href="#" class="footer-link">Our team</a>
                                        <a href="#" class="footer-link">Our interns</a>
                                        <a href="#" class="footer-link">Our content specialists</a>
                                        <a href="#" class="footer-link">Our leadership</a>
                                        <a href="#" class="footer-link">Our supporters</a>
                                        <a href="#" class="footer-link">Our contributors</a>
                                        <a href="#" class="footer-link">Our finances</a>
                                        <a href="#" class="footer-link">Careers</a>
                                        <a href="#" class="footer-link">Internships</a>
                                    </div>
                                    <div class="col-md-4">
                                        <p class="footer-subtitle">Contact</p>
                                        <a href="#" class="footer-link">Help center</a>
                                        <a href="#" class="footer-link">Support community</a>
                                        <a href="#" class="footer-link">Share your story</a>
                                        <a href="#" class="footer-link">Press</a><br><br> 
                                    </div>
                                    <div class="col-md-4">
                                        <p class="footer-subtitle">Courses</p>
                                        <a href="#" class="footer-link">Math: Pre-K-8th grade</a>
                                        <a href="#" class="footer-link">Math: Get ready courses</a>
                                        <a href="#" class="footer-link">Math: high school & college</a>
                                        <a href="#" class="footer-link">Test prep</a>
                                        <a href="#" class="footer-link">Science</a>
                                        <a href="#" class="footer-link">computing</a>
                                        <a href="#" class="footer-link">Arts & humanities</a>
                                        <a href="#" class="footer-link">Economics</a>
                                        <a href="#" class="footer-link">Reading & language arts</a>
                                        <a href="#" class="footer-link">Life skills</a>              
                                    </div>
                                </div>
                            </div>
                            <div class="d-block d-md-none">
                                <div class="row">
                                    <div class="col-6">
                                        <a href="#" class="footer-link">About</a>
                                        <a href="#" class="footer-link">News</a>
                                        <a href="#" class="footer-link">Impact</a>
                                        <a href="#" class="footer-link">Our team</a>
                                        <a href="#" class="footer-link">Our interns</a>
                                        <a href="#" class="footer-link">Our content specialists</a>
                                        <a href="#" class="footer-link">Our leadership</a>
                                        <a href="#" class="footer-link">Our supporters</a>
                                        <a href="#" class="footer-link">Our contributors</a>
                                        <a href="#" class="footer-link">Our finances</a>
                                        <a href="#" class="footer-link">Careers</a>
                                        <a href="#" class="footer-link">Internships</a><br><br>
                                        <p class="footer-subtitle">Contact</p>
                                        <a href="#" class="footer-link">Help center</a>
                                        <a href="#" class="footer-link">Support community</a>
                                        <a href="#" class="footer-link">Share your story</a>
                                        <a href="#" class="footer-link">Press</a><br><br>
                                    </div>
                                    <div class="col-6">
                                        <p class="footer-subtitle">Download our apps</p>
                                        <a href="#" class="footer-link">iOS app</a>
                                        <a href="#" class="footer-link">Android app</a><br><br>
                                        <p class="footer-subtitle">Courses</p>
                                        <a href="#" class="footer-link">Math: Pre-K-8th grade</a>
                                        <a href="#" class="footer-link">Math: Get ready courses</a>
                                        <a href="#" class="footer-link">Math: high school & college</a>
                                        <a href="#" class="footer-link">Test prep</a>
                                        <a href="#" class="footer-link">Science</a>
                                        <a href="#" class="footer-link">computing</a>
                                        <a href="#" class="footer-link">Arts & humanities</a>
                                        <a href="#" class="footer-link">Economics</a>
                                        <a href="#" class="footer-link">Reading & language arts</a>
                                        <a href="#" class="footer-link">Life skills</a>              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <div>
                </div>
                </div>-->
                <div class="footer-bottom">
                    <div class="row">
                        <div class="bottom-links col-md-6">
                            <span>© 2020-2021 EODY </span>
                            <a class="bottom-link" href="#">Terms of use</a>
                            <a class="bottom-link" href="#">Privacy Policy</a>
                        </div>
                        <!--  <div class="social-links col-md-6">
                            <a class="social-link"><i class="fab fa-facebook-f"></i></a>
                            <a class="social-link"><i class="fab fa-twitter"></i></a>
                            <a class="social-link"><i class="fab fa-instagram"></i></a>
                        </div>-->
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { HTTP, getAuthorizationHeader } from "./_helper/http-constants"
export default {
    name: "app",
    data() {
        return {
            disableLeftPadding: false,
            disableTopPadding: false,
            loginHeader: false,
            loginFooter: false,
            user: JSON.parse(localStorage.getItem("user")),
        }
    },
    watch: {
        $route(e) {
            const user = JSON.parse(localStorage.getItem("user"))
            console.log("route name is", e.name, user)
            if (user && user.role.name === "student" && !user.passwordUpdated) {
                this.$router.push({
                    name: "change-password",
                    query: { message: "It is required to update your password to continue!" },
                })
                console.log("you have not updated your password")
            }
            const staticPages = [
                "whyeody.videos",
                "whyeody.practice",
                "whyeody.tests",
                "whyeody.doubts",
                "landing.subjects",
                "landing.courses",
                "landing.topics",
            ]

            if (
                e.name === "landing" ||
                e.name === "register_with_school" ||
                e.name === "login_with_school" ||
                e.name === "login" ||
                e.name === "register" ||
                staticPages.includes(e.name)
            ) {
                console.log("true login header")

                if (this.user) {
                    this.$router.push({ name: "my-account" })
                }
                this.loginHeader = true
                this.loginFooter = true
            } else {
                this.loginHeader = false
                this.loginFooter = false
            }

            const disablePaddingRoutes = [
                "register_with_school",
                "login_with_school",
                "forgot-password",
                ...staticPages,
            ]

            if (disablePaddingRoutes.includes(e.name)) {
                this.disableLeftPadding = true
                this.disableTopPadding = true
            } else {
                this.disableLeftPadding = false
                this.disableTopPadding = false
            }
        },
    },
    methods: {
        login(data) {
            this.isLoggedIn = true
            this.firstName = data.firstName
            this.lastName = data.lastName
            this.loginHeader = true
            this.loginFooter = true
        },
        logout() {
            console.log("app logout running")
            const href = this.$router.resolve({ name: "login" }).href
            window.localStorage.removeItem("user")
            window.localStorage.removeItem("isLogged")
            window.location.href = href
            this.isLoggedIn = false
        },
        hideHeader() {
            this.loginHeader = false
        },
        hideFooter() {
            this.loginFooter = false
        },
        // fetchUserFromDb() {},
    },
    async mounted() {
        this.loginHeader = true
        this.loginFooter = true

        if (this.user) {
            // refetch latest user details
            const res = await HTTP.get("/users/current", {
                headers: getAuthorizationHeader(),
            })
            localStorage.setItem("user", JSON.stringify({ ...res.data }))
        }
    },
}
</script>

<style scoped lang="scss">
// .vue-template {
//     display: flex;
//     justify-content: flex-start;
//     flex-direction: column;
// }
.dashboard-header-padding {
    padding-top: 80px;
}
</style>
